import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "connections" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "connection-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, _toDisplayString($setup.i18n('SETTINGS')), 1 /* TEXT */),
    _createElementVNode("p", null, _toDisplayString($setup.i18n('VERSION_LABEL')) + " " + _toDisplayString($setup.version), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.settings, (connection) => {
          return (_openBlock(), _createElementBlock("li", {
            onClick: ($event: any) => ($setup.select(connection))
          }, [
            _createElementVNode("input", {
              type: "radio",
              checked: $setup.isSelected(connection)
            }, null, 8 /* PROPS */, _hoisted_3),
            _createTextVNode(" " + _toDisplayString(connection.NAME), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_2))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.selected), (key) => {
          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(key) + ": " + _toDisplayString($setup.getField(key)), 1 /* TEXT */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("button", { onClick: $setup.close }, _toDisplayString($setup.i18n('CLOSE')), 1 /* TEXT */)
  ], 64 /* STABLE_FRAGMENT */))
}